import { useParams } from "react-router";
import { put } from "@common/api/apiShared";
import { ajaxQueue } from "@common/api/ajaxQueue";
import { useDotLegalMutation, useDotLegalQuery, useDotLegalQueryClient } from "@common/hooks/dotLegalReactQuery";
import { InternalAssessmentGroupDraft, InternalAssessmentGroupDraftOverviewModel } from "../InternalAssessmentGroups.types";

export default function useInternalAssessmentGroupDraftOverview() {
    const queryClient = useDotLegalQueryClient();

    const { id } = useParams<{ id: string }>();
    const queryKey = `/internalAssessmentGroups/${id}`;

    const { isLoading, data, refetch } = useDotLegalQuery<InternalAssessmentGroupDraftOverviewModel>(queryKey);

    const updateSelectedAssigneesMutation = useDotLegalMutation(updateSelectedAssigneesApi);

    // Written to the cache before the request so ticking a box is instant. The server stores exactly what is sent,
    // so there is nothing to reconcile afterwards.
    const updateSelectedAssignees = async (selectedAssignees: Array<InternalAssessmentGroupDraft>) => {
        queryClient.setQueryData(queryKey, { ...data, selectedAssignees });

        await ajaxQueue().addRequest(updateSelectedAssigneesMutation.mutateAsync, { selectedAssignees });
    };

    return {
        id,
        data,
        isLoading,
        updateSelectedAssignees,
        refetch,
    };

    async function updateSelectedAssigneesApi(payload: { selectedAssignees: Array<InternalAssessmentGroupDraft> }) {
        return await put(`/internalAssessmentGroups/${id}/drafts`, payload.selectedAssignees);
    }
}
